import React from 'react';
import { Row, Col } from 'antd';
import {
	XThemeVoiceAssTableCard,
	XVSLottie,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
} from '../../VoiceAssistanceStyle';
import BatchLoader from '../../../../json/batch_creation_loader.json';

const VABatchLoader = (props) => {
	const { action } = props;
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24}>
							<div className="hasPadding">
								<Row
									gutter={[15, 15]}
									className="align-items-center justify-content-center"
								>
									<XThemeVSGenerateAL className="h-100">
										<XVSLottie
											className="relativePositions"
											animationData={BatchLoader}
											loop={true}
										/>
									</XThemeVSGenerateAL>
								</Row>
							</div>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VABatchLoader;
